import posthog from 'posthog-js';
//import { browser, dev } from '$app/environment';
//import { PUBLIC_POSTHOG_KEY } from '$env/static/public';

let isInitializing = false;
let postHogInstance = null;

export async function initializePostHog() {
  if (postHogInstance || isInitializing) {
    return;
  }
  isInitializing = true;

  try {
    const POSTHOG_KEY = "__VITE_POSTHOG_KEY__";
    if (POSTHOG_KEY.startsWith('__VITE_')) {
      console.warn("Failed to retrieve VITE_POSTHOG_KEY.")
    }

    postHogInstance = posthog.init(POSTHOG_KEY, {
      api_host: 'https://us.i.posthog.com', // or your self-hosted endpoint
      person_profiles: 'identified_only',
    });

    console.log('PostHog is initialized.');

  } catch (e) {
    console.error("Error during PostHog initialization:", e);
  } finally {
      isInitializing = false;
  }
}
